import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore.ts";
import { Personeelsdiensten } from "../Personeelsdiensten/Personeelsdiensten";
import { TijdlijnSchaal } from "../TijdlijnSchaal/TijdlijnSchaal";
import styles from "./WerklijnenContainer.module.css";

interface IWerklijnenContainer {
  scale?: number;
}

export function WerklijnenContainer({ scale = 12 }: Readonly<IWerklijnenContainer>) {
  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;

  return (
    <div className={styles["grid-container"]}>
      <div
        className={styles["grid-item"] + " " + styles["grid-topbar"] + " " + styles["grid-topleft"]}
      ></div>
      <div
        data-topbar
        className={
          styles["grid-item"] + " " + styles["grid-topbar"] + " " + styles["grid-topbar-timeline"]
        }
      >
        <TijdlijnSchaal start={timeLineBegin} eind={timeLineEnd} scale={scale} />
      </div>
      <Personeelsdiensten scale={scale} />
    </div>
  );
}
